/**
 * Tolerant category matcher for frontend filters.
 *
 * Mirrors the backend `_category_matches` helper in /app/backend/server.py.
 * Handles the real-world case where teams may be stored with a division
 * suffix ("M13 Open") while games and the UI use the short code ("M13").
 *
 * Two categories match when their normalized forms are equal, OR when the
 * shorter is a prefix of the longer AND the next remaining char is not a
 * digit (to prevent "M1" from matching "M13" / "M11").
 */

function normalize(cat) {
    if (!cat) return "";
    return String(cat)
        .toLowerCase()
        .normalize("NFKD")
        .replace(/[\u0300-\u036f]/g, "") // strip diacritics
        .replace(/\s+/g, "")
        .replace(/-/g, "");
}

export function categoryMatches(query, stored) {
    const q = normalize(query);
    const s = normalize(stored);
    if (!q || !s) return q === s;
    if (q === s) return true;
    const [short, long_] = q.length <= s.length ? [q, s] : [s, q];
    if (short.length >= 2 && long_.startsWith(short)) {
        const rem = long_.slice(short.length);
        if (!rem || !/^\d/.test(rem[0])) return true;
    }
    return false;
}

export function normalizeCategory(cat) {
    return normalize(cat);
}
